import { motion } from "framer-motion";

export const WHATSAPP_URL = "https://wa.me/2348140635506";

export const IMAGES = {
    hero: "https://images.pexels.com/photos/7108446/pexels-photo-7108446.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1080&w=1920",
    employers:
        "https://images.unsplash.com/photo-1621972660295-0ae270b0b38e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxhZnJpY2FuJTIwZXhlY3V0aXZlJTIwbGVhZGVyc2hpcHxlbnwwfHx8fDE3OTI0NDk4NzF8MA&ixlib=rb-4.1.0&q=85",
    professionals:
        "https://images.pexels.com/photos/7446948/pexels-photo-7446948.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=800",
    students:
        "https://images.unsplash.com/photo-1694175271713-a6e2cc378980?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxhZnJpY2FuJTIwc3R1ZGVudCUyMHVuaXZlcnNpdHklMjBjYW1wdXN8ZW58MHx8fHwxNzkyNDQ4NDkyfDA&ixlib=rb-4.1.0&q=85",
    recruitment:
        "https://images.pexels.com/photos/13801544/pexels-photo-13801544.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    industries:
        "https://images.pexels.com/photos/5234472/pexels-photo-5234472.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    mobility:
        "https://images.unsplash.com/photo-1758531491352-7887c1fe45b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxpbnRlcm5hdGlvbmFsJTIwYWlycG9ydCUyMHRlcm1pbmFsJTIwdHJhdmVsfGVufDB8fHx8MTc5MjQ0ODQ5Mnww&ixlib=rb-4.1.0&q=85",
    study: "https://images.pexels.com/photos/16476674/pexels-photo-16476674.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const Reveal = ({ children, delay = 0, className = "" }) => (
    <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
        className={className}
    >
        {children}
    </motion.div>
);

export const Eyebrow = ({ children, dark = false }) => (
    <span
        className={`inline-flex items-center gap-3 text-[11px] font-medium uppercase tracking-[0.3em] ${
            dark ? "text-ivory/70" : "text-forest"
        }`}
    >
        <span className="h-px w-8 bg-champagne" aria-hidden="true" />
        {children}
    </span>
);
